import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccountManagerState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AccountManagerState = {
  data: [],
  isLoading: false,
  error: null,
};

const accountManagerSlice = createSlice({
  name: 'accountManagers',
  initialState,
  reducers: {
    setAccountManagers: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAccountManagerLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAccountManagerError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setAccountManagers, setAccountManagerLoading, setAccountManagerError } = accountManagerSlice.actions;

export default accountManagerSlice.reducer;
